import { FormattedMessage } from "react-intl";
import EditIcon from "../../../components/Common/SvgIcons/TableIcons/EditIcon";
import FailedIcon from "../../../components/Common/SvgIcons/TableIcons/FailedIcon";
import InformationIcon from "../../../components/Common/SvgIcons/TableIcons/InformationIcon";
import InProcessingIcon from "../../../components/Common/SvgIcons/TableIcons/InProcessingIcon";
import NotConnectedIcon from "../../../components/Common/SvgIcons/TableIcons/NotConnectedIcon";
import NotSupportedIcon from "../../../components/Common/SvgIcons/TableIcons/NotSupportedIcon";
import SuccessIcon from "../../../components/Common/SvgIcons/TableIcons/SuccessIcon";
import TranscribeIcon from "../../../components/Common/SvgIcons/TableIcons/TranscribeIcon";
import ViewIcon from "../../../components/Common/SvgIcons/TableIcons/ViewIcon";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
import { tableColumnTypes } from "../../tableColumnTypes";
import { createShotclasses } from "./createShotclasses";

export const manageTranscription = {
  label: "Manage Transcription",
  path: (tenantName) => `/${tenantName}/manage/manageTranscription`,
  buttons: (handleViewContentModal) => [
    {
      key: 1,
      label: "View Content",
      icon: ViewIcon,
      onClick: () => handleViewContentModal(),
    },
  ],
  columns: (navigate, handleTranscribe = () => {}, tenantName) => [
    {
      ID: 1,
      name: <FormattedMessage id="Report_ShotClass_Name" />,
      fieldName: "Name",
      value: (row) => (
        <div title={row?.Name}>
          {row?.Name?.length > 25 ? row?.Name?.slice(0, 23) + "..." : row?.Name}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="MYCLASS_DATEMODIFY" />,
      fieldName: "transcribe_datetime",
      value: (row) =>
        row.transcribe_datetime
          ? new Date(row.transcribe_datetime).toLocaleString()
          : "",
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 3,
      name: <FormattedMessage id="SOURCE_TYPE_TEXT" />,
      fieldName: "SourceType",
      value: (row) => row.SourceType,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 4,
      name: <FormattedMessage id="MYCLASS_LANGUAGE" />,
      fieldName: "Language",
      value: (row) => row.Language,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 5,
      name: "Transcribe Status",
      fieldName: "TranscribeStatus",
      value: (row) => (
        <>
          {row.SourceType === "NoContent" ||
          row.SourceType === "Slideshare" ||
          row.SourceType === "Youtube" ||
          row.SourceType === "HTML5" ||
          row.SourceType === "SCORM" ||
          row.SourceType === "MOOC" ? (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#e30202",
              }}
            >
              <NotSupportedIcon />
              Not Supported
              <Tooltip
                content={
                  <>
                    Currently {row.SourceType} is not
                    <br /> supported
                  </>
                }
                direction={"bottom"}
              >
                <InformationIcon />
              </Tooltip>
            </span>
          ) : row.TranscribeStatus === "Not Connected" ||
            row.TranscribeStatus === "Started Connect" ? (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#B5B5B5",
              }}
            >
              <NotConnectedIcon />
              Not Connected
            </span>
          ) : row.TranscribeStatus === "In-Progress" ||
            row.TranscribeStatus === "Started Processing.." ? (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffa800",
              }}
            >
              <InProcessingIcon />
              {row.TranscribeStatus === "In-Progress"
                ? "In-Progress"
                : "Started Processing.."}
            </span>
          ) : row.TranscribeStatus === "Success" ? (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#14C037",
              }}
            >
              <SuccessIcon />
              Success
            </span>
          ) : row.TranscribeStatus === "Failed" ? (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#e51717",
              }}
            >
              <FailedIcon />
              Failed
              <Tooltip
                content={
                  <>
                    Document not uploaded in Engine due to
                    <br />
                    "Network Error - 404"
                  </>
                }
                direction={"bottom"}
              >
                <InformationIcon />
              </Tooltip>
            </span>
          ) : (
            <></>
          )}
        </>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 6,
      name: <FormattedMessage id="Cer_Actions" />,
      fieldName: "",
      value: (row) => (
        <>
          {row.TranscribeStatus === "In-Progress" ||
          row.TranscribeStatus === "Success" ? (
            <Tooltip
              content={<FormattedMessage id="MYCLASS_EDIT" />}
              show={row.TranscribeStatus === "Success"}
              direction={"bottom"}
            >
              <span
                onClick={() => {
                  if (row.TranscribeStatus === "Success") {
                    localStorage.setItem(
                      "shotclassTypeFrom",
                      "manageTrascription"
                    );
                    navigate(
                      `${createShotclasses.edittranscribepath(tenantName)}/${
                        row.course_id
                      }`,
                      {
                        state: { from: "manageTrascription" },
                      }
                    );
                  } else {
                    return undefined;
                  }
                }}
              >
                <EditIcon disabled={row.TranscribeStatus === "In-Progress"} />
              </span>
            </Tooltip>
          ) : (
            <Tooltip
              content={
                row.TranscribeStatus === "Failed" ? (
                  <>
                    Re-
                    <br />
                    Transcribe
                  </>
                ) : (
                  "Transcribe"
                )
              }
              show={
                row.TranscribeStatus !== "Started Processing.." &&
                row.SourceType !== "NoContent" &&
                row.SourceType !== "Slideshare" &&
                row.SourceType !== "Youtube" &&
                row.SourceType !== "MOOC"
              }
              direction={"bottom"}
            >
              <span
                onClick={() => {
                  if (
                    row.TranscribeStatus !== "Started Processing.." &&
                    row.SourceType !== "NoContent" &&
                    row.SourceType !== "Slideshare" &&
                    row.SourceType !== "Youtube" &&
                    row.SourceType !== "MOOC"
                  ) {
                    handleTranscribe(row.course_id);
                  }
                }}
              >
                <TranscribeIcon
                  reTranscribe={row.TranscribeStatus === "Failed"}
                  disabled={
                    row.TranscribeStatus === "Started Processing.." ||
                    row.SourceType === "NoContent" ||
                    row.SourceType === "Slideshare" ||
                    row.SourceType === "Youtube" ||
                    row.SourceType === "MOOC"
                  }
                />
              </span>
            </Tooltip>
          )}
        </>
      ),
      sort: false,
    },
  ],
  // editColumns: () => [
  //   {
  //     ID: 1,
  //     name: "Page Number",
  //     fieldName: "page_no",
  //     value: (row) => row.page_no,
  //     type: tableColumnTypes.NUMBER,
  //   },
  //   {
  //     ID: 2,
  //     name: "Tag",
  //     fieldName: "section_tags",
  //     value: (row) =>
  //     <Input
  //         label={"Name"}
  //         name={"ShotClassName"}
  //         labelColor={ "light"}
  //         onChange={ handleNameExists}
  //         required={ true}
  //         disabled={ shotclassType}
  //     />
  //     row.section_tags,
  //     type: tableColumnTypes.DATE,
  //   },
  //   {
  //     ID: 3,
  //     name: "Transcript",
  //     fieldName: "content_body",
  //     value: (row) => row.content_body,
  //     type: tableColumnTypes.STRING,
  //   },
  // ],
};
